import React from 'react';
import { useLang } from '../i18n/LangContext';
import { HERO_IMAGE } from '../data/content';
import { MapPin, ChevronDown } from 'lucide-react';

export default function Hero() {
  const { t } = useLang();

  const scrollNext = () => {
    const el = document.getElementById('about');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-[100svh] min-h-[620px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover scale-[1.15] md:scale-[1.12]"
        style={{ backgroundImage: `url(${HERO_IMAGE})`, backgroundPosition: '72% 55%' }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/10 to-black/75" />

      <div className="relative z-10 h-full max-w-7xl mx-auto px-5 md:px-10 flex flex-col justify-end pb-14 md:pb-24">
        <div className="inline-flex items-center gap-2 self-start bg-white/12 backdrop-blur-md border border-white/25 rounded-full px-4 py-1.5 mb-6">
          <span className="h-1.5 w-1.5 rounded-full bg-[#A9BE8A]" />
          <span className="text-white text-[11px] uppercase tracking-[0.22em] font-medium">
            {t.welcome}
          </span>
        </div>

        <p className="text-white/85 text-[11px] md:text-[12px] uppercase tracking-[0.28em] mb-4">
          {t.tagline}
        </p>
        <h1 className="font-serif text-white text-[54px] leading-[0.95] md:text-[104px] md:leading-[0.95] tracking-tight">
          Obach Rural
        </h1>
        <div className="mt-5 flex items-center gap-2 text-white/90">
          <MapPin size={16} className="opacity-80" />
          <span className="text-sm md:text-base font-light">{t.location}</span>
        </div>
      </div>

      <button
        onClick={scrollNext}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 text-white/80 hover:text-white transition-colors flex flex-col items-center gap-1"
        aria-label="scroll down"
      >
        <span className="text-[10px] uppercase tracking-[0.28em]">Scroll</span>
        <ChevronDown size={18} className="animate-bounce" />
      </button>
    </section>
  );
}
